import React, { useEffect, useState } from "react";

import { ButtonWithIcon } from "../ButtonWithIcon";
import { ErrorHeader } from "../HeaderBar";
import LexWorkplaceLogo from "../../svg/LexWorkplaceLogo";
import "./FullPageError.css";
import { IconLogout, IconProgressHelp } from "@tabler/icons-react";
import { LexWorkplaceRefreshIcon } from "../LexWorkplaceIcons";

// rateLimitRetryAfterSeconds is set when the app couldn't load because the
// user was rate limited; reloading is disabled until it counts down
const FullPageError = ({ logOut, rateLimitRetryAfterSeconds }) => {
	const rateLimited = rateLimitRetryAfterSeconds != null;
	const [secondsLeft, setSecondsLeft] = useState(
		rateLimitRetryAfterSeconds || 0
	);

	useEffect(() => {
		if (secondsLeft <= 0) {
			return;
		}
		const timer = setTimeout(() => setSecondsLeft(secondsLeft - 1), 1000);
		return () => clearTimeout(timer);
	}, [secondsLeft]);

	const handleReload = () => {
		window.location.reload();
	};

	return (
		<div className="App">
			<ErrorHeader />
			<div className="full-page-error">
				<div>
					<div className="error-content">
						<div className="error-logo">
							<LexWorkplaceLogo />
						</div>
						<div className="error-text-block">
							<div className="error-title">
								{rateLimited
									? "TOO MANY REQUESTS"
									: "CRITICAL ERROR"}
							</div>
							<div className="error-text">
								LexWorkplace could not be loaded
							</div>
							<div className="error-subtext">
								{rateLimited
									? "You are making requests too quickly. Please wait a moment, then reload the page."
									: "Please reload your page or contact Uptime Legal support"}
							</div>
						</div>
					</div>
					<div className="error-buttons">
						<ButtonWithIcon
							handler={handleReload}
							disabled={secondsLeft > 0}
							buttonText={
								secondsLeft > 0
									? `Reload Page (${secondsLeft})`
									: "Reload Page"
							}
							iconComponent={<LexWorkplaceRefreshIcon />}
						/>
						<a
							href="https://help.lexworkplace.com/"
							target="_blank"
							rel="noopener noreferrer"
							className="error-button-link"
						>
							<ButtonWithIcon
								buttonText="Contact Support"
								iconComponent={
									<IconProgressHelp
										size={20}
										style={{ verticalAlign: "middle" }}
									/>
								}
							/>
						</a>
						<ButtonWithIcon
							handler={logOut}
							buttonText="Log Out"
							iconComponent={
								<IconLogout
									size={20}
									style={{ verticalAlign: "middle" }}
								/>
							}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FullPageError;
